import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'

const WarehouseAttrPopup = ({ body }) => {
  const { goBack } = useHistory()
  const { t } = useTranslation('map')

  return (
    <Popup>
      <div className='popup__title'>
        <div>{t('whatDoAttributesMean')}</div>
      </div>
      <div className='popup__infoBlocks'>
        {body?.map((item) => {
          return (
            <div key={item.id} className={`lockItem lockItem--info`}>
              <div><i className='icon icon--byapp'></i>{item.name} </div>
              <div>{item.description}</div>
            </div>
          )
        })}
        <ArrowBtn
          enlarged
          showArrow={false}
          text={t('IUnderstand')}
          action={goBack} />
      </div>
    </Popup>
  )
}

export default WarehouseAttrPopup